require('./_wks-define')('asyncIterator');


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/~/core-js/modules/es7.symbol.async-iterator.js
// module id = 432
// module chunks = 0